import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20gradient%20waves%20in%20warm%20coral%20and%20cream%20tones%2C%20soft%20geometric%20shapes%20floating%2C%20minimalist%20digital%20art%2C%20elegant%20smooth%20curves%2C%20light%20airy%20atmosphere%2C%20modern%20design%20aesthetic&width=1800&height=900&seq=hero-bg-bitbi&orientation=landscape"
          alt="逼特逼视频平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-sm text-background-50 font-medium">2024最新版全新上线</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 mb-6 leading-tight">
          发现世界的
          <span className="text-primary-300">每一种精彩</span>
        </h1>

        <p className="text-lg md:text-xl text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          逼特逼视频汇集海量优质视频内容，覆盖娱乐、教育、科技、生活等八大领域，
          为您打造个性化视频体验，让每一次观看都充满惊喜。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/entertainment"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即探索内容
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-background-50/40 text-background-50 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-all duration-200"
          >
            <i className="ri-information-line mr-2"></i>
            了解平台
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 max-w-3xl mx-auto">
          {[
            { value: '2.8亿+', label: '月活用户' },
            { value: '15亿+', label: '日均播放' },
            { value: '500万+', label: '创作者' },
            { value: '8大', label: '内容分类' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-300 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}